/**
 * Mobile Nav: Auto-Open für .current-menu-ancestor + Akkordeon (genau 1 Submenu offen).
 * Robust gegen WP Block Interactivity (Hydration).
 */
export function initMobileNavigation(root = document) {
  const nav = root.querySelector('#site-mobilenav .wp-block-navigation');
  if (!nav) return;

  // helpers
  const toggles = () => nav.querySelectorAll('.wp-block-navigation-submenu__toggle');
  const liOf     = (btn) => btn?.closest('.wp-block-navigation-submenu') || null;
  const subOf    = (li)  => li?.querySelector(':scope > .wp-block-navigation__submenu-container') || null;

  let bindingsDetached = false;

  function detachBindingsOnce() {
    if (bindingsDetached) return;
    for (const btn of toggles()) {
      if (btn.hasAttribute('data-wp-bind--aria-expanded')) btn.removeAttribute('data-wp-bind--aria-expanded');
      if (btn.hasAttribute('data-wp-on-async--click'))     btn.removeAttribute('data-wp-on-async--click');
    }
    bindingsDetached = true;
  }

  function openOnly(btnToOpen) {
    // genau ein Submenu offen
    for (const btn of toggles()) {
      const li  = liOf(btn);
      const sub = subOf(li);
      const isTarget = btn === btnToOpen;

      btn.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
      if (sub) {
        if (isTarget) sub.removeAttribute('hidden');
        else sub.setAttribute('hidden', '');
      }
      if (li) li.classList.toggle('is-open-by-script', !!isTarget);
    }
  }
  const closeAll = () => openOnly(null);

  function applyInitialOpen() {
    detachBindingsOnce();
    const currentBtn = nav.querySelector('.current-menu-ancestor > .wp-block-navigation-submenu__toggle');
    if (currentBtn) openOnly(currentBtn);
  }

  // Akkordeon per Click-Delegation (wir übernehmen komplett die Kontrolle)
  nav.addEventListener('click', (e) => {
    const btn = e.target instanceof Element && e.target.closest('.wp-block-navigation-submenu__toggle');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    detachBindingsOnce();
    const isOpen = btn.getAttribute('aria-expanded') === 'true';
    if (isOpen) closeAll();
    else openOnly(btn);
  }, true); // capture: vor evtl. WP-Handlern

  // Hydration-fest (ohne Schleifen)
  requestAnimationFrame(applyInitialOpen);      // falls Hydration bereits fertig
  setTimeout(applyInitialOpen, 120);            // kleiner Fallback

  // einmalig reagieren, falls WP Bindings nachträglich anbringt
  const mo = new MutationObserver((list, obs) => {
    for (const m of list) {
      if (m.type === 'attributes' && m.attributeName === 'data-wp-bind--aria-expanded') {
        applyInitialOpen();
        obs.disconnect(); // einmal & gut
        break;
      }
    }
  });
  mo.observe(nav, { subtree: true, attributes: true, attributeFilter: ['data-wp-bind--aria-expanded'] });
}
